import { render, staticRenderFns } from "./PartnerProductAccountPeriodList.vue?vue&type=template&id=68af01af&scoped=true&"
import script from "./PartnerProductAccountPeriodList.vue?vue&type=script&lang=js&"
export * from "./PartnerProductAccountPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af01af",
  null
  
)

export default component.exports